import { NoticeFactory } from '@b2b/common/factories/notice';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IPromise, IQService, IScope, ITimeoutService } from 'angular';
import { OrdersModalsRequestControllerModule } from '../../../orders/modals/request/controllers/OrdersModalsRequestController';

SettingsTerminalsController.$inject = [
  '$scope',
  '$uibModal',
  '$filter',
  '$timeout',
  '$state',
  '$q',
  'ApiService',
  'PermissionsService',
  'TerminalsService',
  'NoticeFactory',
  'GridStateFactory',
  'HelpersService',
  'GridDefinitionFactory',
  'terminalId',
  'CustomFieldsData',
  'PosCloudConfigurationService',
  'FeatureToggleService',
];

function SettingsTerminalsController(
  $scope: IScope & { settingsTerminals: TODO },
  $uibModal: UIBModalService,
  $filter: IFilterService,
  $timeout: ITimeoutService,
  $state: StateService,
  $q: IQService,
  ApiService: ApiService,
  PermissionsService: PermissionsService,
  TerminalsService: TODO,
  NoticeFactory: NoticeFactory,
  GridStateFactory: TODO,
  HelpersService: TODO,
  GridDefinitionFactory: TODO,
  terminalId: string,
  CustomFieldsData: TODO,
  PosCloudConfigurationService: TODO,
  FeatureToggleService: TODO
) {
  const ctrl = {
    model: [] as TODO[],
    filtered: [] as TODO[],
    selected: {},
    createModal: {} as UIBModal<TODO>,
    selectedItems: [] as TODO[],
    selectedRows: [] as TODO[],
    templatesData: {},
    types: TerminalsService.types,

    viewId: '',
    queryTimer: false as IPromise<void> | false,
    searchQuery: terminalId || '',
    settingsTerminalsGridName: $state.current.name + '.grid0',

    isLoaded: false,

    showModal: null as UIBModal<TODO> | null,
    templatesModal: null as UIBModal<TODO> | null,

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    notice: new NoticeFactory(),

    optionsOverride: {
      data: 'settingsTerminals.filtered',
      multiSelect: true,
      noUnselect: false,
      useAccessibleGrid: true,
      appScopeProvider: {
        onDataGridPaginate: function (newPageNumber, newPageSize, sortField, sortDirection) {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: function (grid, columns, page) {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        remove: function (terminal, e) {
          ctrl.remove(terminal, e);
        },
        assignConfiguration: function (row, col, e) {
          ctrl.assignConfiguration(row, col, e);
        },
        showCloudConfiguration: function (row) {
          ctrl.showCloudConfiguration(row);
        },
        showTerminalsModal: function (row) {
          ctrl.showTerminalsModal(row);
        },
        onDataGridSelectionChange: function (row, e) {
          ctrl.onDataGridSelectionChange(row);
        },
        onAfterCellEdit: function (terminal, e) {
          ctrl.update(terminal);
        },
        getTypeLabel: function (type) {
          return ctrl.getTypeLabel(type);
        },
      },
      columnDefs: [
        {
          field: 'terminalId',
          displayName: 'Terminal Id',
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEdit: true,
          enableCellEditOnFocus: true,
          cellEditableCondition: PermissionsService.check('POS_SALE_TERMINALS_UPDATE'),
        },
        {
          field: 'name',
          displayName: 'Name',
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEdit: true,
          enableCellEditOnFocus: true,
          cellEditableCondition: PermissionsService.check('POS_SALE_TERMINALS_UPDATE'),
          sort: {
            direction: 'asc',
          },
        },
        {
          field: 'description',
          displayName: 'Description',
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEdit: true,
          enableCellEditOnFocus: true,
          cellEditableCondition: PermissionsService.check('POS_SALE_TERMINALS_UPDATE'),
        },
        {
          field: 'type',
          displayName: 'Type',
          cellTemplate:
            '<div class="ui-grid-cell-contents"><span>{{ grid.appScope.getTypeLabel(row.entity.type) }}</span></div>',
        },
        {
          field: 'templatesMap',
          displayName: 'Valid Events',
          onCellNavClick: function (row) {
            ctrl.showTerminalsModal(row.entity);
          },
          enableHiding: false,
          enableSorting: false,
          cellTemplate: 'views/application/views/settings/terminals/terminals.column.validEvents.tpl.html',
        },
        {
          field: 'amount',
          displayName: 'Cash Amount',
          cellFilter: 'currency',
          cellFormatter: function (item) {
            return $filter('currency')(item.value);
          },
          editableCellTemplate: 'common/includes/cellEditorTemplate.tpl.html',
          enableCellEdit: true,
          enableCellEditOnFocus: true,
          cellEditableCondition: PermissionsService.check('POS_SALE_TERMINALS_UPDATE'),
          visible: false,
        },
        {
          field: 'configName',
          displayName: 'Configuration',
          onCellNavClick: function (row, col, e) {
            ctrl.assignConfiguration(row.entity, col, e);
          },
          enableHiding: false,
          enableSorting: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><span data-ng-show="row.entity.type === \'pos\'"><a data-ng-click="grid.appScope.assignConfiguration(row.entity, null, $event)" title="Configuration Name" data-ng-if="row.entity.configName">{{ row.entity.configName }}</a> <a data-ng-click="grid.appScope.assignConfiguration(row.entity, null, $event)" data-ng-if="!row.entity.configName">ACME System Default</a></span><span class="inactive" data-ng-show="row.entity.type === \'kiosk\'">N/A</span></div>',
        },
      ],
    },

    init: function () {
      ctrl.viewId = $state.current.name ?? '';

      ctrl.gridDefinition.init(
        ctrl.settingsTerminalsGridName,
        ctrl.optionsOverride,
        ctrl.viewId,
        $state.current.data.enablePreferences
      );

      $scope.$emit('Application::contentTitleChange', {
        title: 'Terminals',
        buttonRight: {
          label: 'Add Terminal',
          permissions: ['POS_SALE_TERMINALS_CREATE'],
          action: function () {
            ctrl.create();
          },
        },
      });

      if (PermissionsService.check('POS_SALE_TERMINALS_DELETE')) {
        ctrl.optionsOverride.columnDefs.push({
          field: 'remove',
          displayName: 'Remove',
          onCellNavClick: function (row, col) {
            ctrl.remove(row.entity);
          },
          cellTemplate:
            '<div class="ui-grid-cell-contents" title="TOOLTIP"><a data-ng-click="grid.appScope.remove(row.entity, $event)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>',
          enableHiding: false,
          enableSorting: false,
        });
      }

      $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData);

      // Add POS Cloud Config
      if (PermissionsService.check('CSR')) {
        ctrl.optionsOverride.columnDefs.push({
          field: 'cloudConfig',
          displayName: 'Cloud Configuration',
          onCellNavClick: function (row) {
            ctrl.showCloudConfiguration(row.entity);
          },
          enableHiding: false,
          enableSorting: false,
          cellTemplate: 'views/application/views/settings/terminals/terminals.column.posCloudConfiguration.tpl.html',
        });
      }

      $scope.$on('destroy', function () {
        if (ctrl.queryTimer) {
          $timeout.cancel(ctrl.queryTimer);
        }
      });
    },

    initData: function () {
      const props = ctrl.gridDefinition.getGridState();
      ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      ctrl.getTerminals();
    },

    getTerminals: function (withLoadingFlag = false) {
      if (withLoadingFlag) {
        ctrl.isLoaded = false;
        ctrl.gridDefinition.isLoaded = false;
      }

      ApiService.terminals
        .list(ctrl.gridState.getGridState())
        .then(ctrl.success.getTerminals)
        .catch(ctrl.error.getTerminals);
    },

    findTerminal: function (id) {
      let result: TODO = false;

      for (let i = 0, ii = ctrl.model.length; i < ii; i++) {
        if (ctrl.model[i].id === id) {
          result = {
            index: i,
            entity: ctrl.model[i],
          };
        }
      }

      return result;
    },

    getTypeLabel: function (type) {
      let result = 'No such type';
      const found = TerminalsService.findType(type);

      if (found) {
        result = found.type.label;
      }

      return result;
    },

    create: function () {
      ctrl.notice.hideErrorMessages();
      ctrl.notice.hideSuccessMessages();

      ctrl.createModal = $uibModal.open({
        templateUrl: 'views/application/views/settings/terminals/modals/createTerminal.tpl.html',
        size: 'lg',
        controller: 'SettingsTerminalsCreateModalController',
        resolve: {
          terminals: function () {
            return ctrl.model;
          },
          config: function () {
            return ApiService.pos.list(HelpersService.getPaginator());
          },
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.createModal.result.then(ctrl.createTerminal, function () {
        // Do nothing
      });
    },

    createTerminal: function (terminal) {
      ctrl.notice.hideSuccessMessages();
      ctrl.notice.hideErrorMessages();
      ApiService.terminals.create(terminal).then(ctrl.getTerminals, ctrl.error.create);
    },

    update: function (terminal) {
      console.log('SettingsTerminalController::update', terminal);
      if (terminal && PermissionsService.check('POS_SALE_TERMINALS_UPDATE')) {
        ApiService.terminals.update(terminal).then(ctrl.success.update, ctrl.error.update);
      }
    },

    remove: function (terminal: TODO, e?: Event) {
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }
      ctrl.notice.hideErrorMessages();
      ctrl.notice.hideSuccessMessages();

      ctrl.createModal = $uibModal.open({
        templateUrl: 'views/application/views/settings/terminals/modals/removeTerminal.tpl.html',
        size: 'lg',
        controller: 'SettingsTerminalsRemoveModalController',
        resolve: {
          currentTerminal: function () {
            return terminal;
          },
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.createModal.result.then(
        function () {
          ctrl.notice.hideSuccessMessages();
          ctrl.notice.hideErrorMessages();
          ApiService.terminals.remove(terminal.id).then(function (response) {
            const found = ctrl.findTerminal(terminal.id);
            if (found) {
              ctrl.model.splice(found.index, 1);
              ctrl.search();
              ctrl.success.remove(response);
            }
          }, ctrl.error.remove);
        },
        function () {
          // Do nothing
        }
      );
    },

    search: function () {
      ctrl.filtered = $filter('filter')(ctrl.model, function (terminal: TODO) {
        const id = terminal.terminalId ? terminal.terminalId : '';
        const name = terminal.name ? terminal.name : '';
        const desc = terminal.description ? terminal.description : '';
        const configName = terminal.configName ? terminal.configName : '';
        const value = (id + name + desc + configName).toLowerCase();
        return value.indexOf(ctrl.searchQuery.toLowerCase()) !== -1 ? terminal : null;
      });
    },

    query: function () {
      if (ctrl.queryTimer) {
        $timeout.cancel(ctrl.queryTimer);
      }

      ctrl.queryTimer = $timeout(function () {
        ctrl.search();
        $scope.$broadcast('DataGrid::ResizeGrid', {
          name: ctrl.gridDefinition.options.gridName,
          datasetLength: ctrl.filtered.length,
        });
      }, 500);
    },

    assignConfiguration: function (row, col, e) {
      if (e && typeof e.stopPropagation === 'function') {
        e.stopPropagation();
      }

      if (ctrl.selectedRows.length || row) {
        if (
          ctrl.selectedRows.length &&
          row &&
          ctrl.selectedRows.some(function (obj, idx) {
            return obj.data.id === row.id;
          })
        ) {
          ctrl.openAssignModal(ctrl.selectedRows);
        } else {
          ctrl.selectedRows.push({ data: row, selected: true });
          ctrl.openAssignModal(ctrl.selectedRows);
        }
      }
    },

    showCloudConfiguration: function (entity) {
      PosCloudConfigurationService.getConfigurationByTerminalId(entity.terminalId).then(
        ctrl.openPosCloudConfigurationModal,
        ctrl.openPosCloudConfigurationModal
      );
    },

    openPosCloudConfigurationModal: function (response) {
      $uibModal.open({
        templateUrl: 'views/application/views/settings/terminals/modals/posCloudConfigurationModal.tpl.html',
        size: 'lg',
        controller: 'SettingsTerminalsPosCloudConfigurationModalController',
        controllerAs: '$ctrl',
        resolve: {
          response: function () {
            return response;
          },
        },
      });
    },

    openAssignModal: function (selectedRows) {
      ctrl.createModal = $uibModal.open({
        templateUrl: 'views/application/views/settings/terminals/modals/assignConfiguration.tpl.html',
        size: 'md',
        controller: 'SettingsTerminalsConfigurationModalController',
        resolve: {
          selectedRows: function () {
            return selectedRows;
          },
        },
      });

      // Invoked when modal completes with close(params)
      ctrl.createModal.result.then(
        function (res) {
          ApiService.terminals.config.update(res).then(ctrl.getTerminals);
          ctrl.selectedRows = [];
          ctrl.clearSelectedItems();
        },
        function () {
          ctrl.selectedRows = [];
          ctrl.clearSelectedItems();
        }
      );
    },

    clearSelectedItems: function () {
      // Wait for selection change event AG-GRID
      ctrl.gridDefinition.clearSelection();
    },

    addTerminalsModal(row: TODO) {
      const terminalId = row.terminalId;
      const templateIds: TODO[] = row.templateIds || [];

      ctrl.showModal = $uibModal.open({
        templateUrl: 'views/application/views/orders/modals/request/request.tpl.html',
        size: 'lg',
        controller: 'OrdersModalsRequestController',
        resolve: {
          customFields: () => {
            return CustomFieldsData.data.success ? CustomFieldsData.data.payload.list : [];
          },
          eventTemplates: () => {
            return templateIds.map((templateId) => ({ id: templateId }));
          },
        },
      });

      ctrl.showModal?.result.then((selectedEventTemplates) => {
        const templateIds = selectedEventTemplates.map(function (template) {
          return template.id;
        });

        ctrl.isLoaded = false;
        ctrl.gridDefinition.isLoaded = false;

        ApiService.terminals.templates.update(terminalId, templateIds).then(() => {
          ctrl.getTerminals(true);
        });
      });
    },

    showTerminalsModal(row) {
      ctrl.addTerminalsModal(row);
    },

    onDataGridSelectionChange: function (row: TODO | TODO[]) {
      let unique = true;

      if (Array.isArray(row)) {
        for (let i = 0, ii = row.length; i < ii; i++) {
          ctrl.selectedRows[row[i].entity.id] = { selected: row[i].isSelected, data: row[i].entity };
        }
      } else if (row.isSelected) {
        for (let i = 0, ii = ctrl.selectedRows.length; i < ii; i++) {
          if (row.entity.id === ctrl.selectedRows[i].data.id) {
            unique = false;
          }
        }
        if (unique) {
          ctrl.selectedRows.push({ selected: row.isSelected, data: row.entity });
        }
      } else if (!row.isSelected && ctrl.selectedRows.length) {
        ctrl.selectedRows = ctrl.selectedRows.filter(function (obj, i) {
          if (row.entity.id === ctrl.selectedRows[i].data.id) {
            return false;
          }
          return true;
        });
      }
    },

    pullTemplatesData: function (terminals) {
      const templatesPromises: TODO[] = [];

      terminals.forEach(function (terminal) {
        if (terminal.templateIds && terminal.templateIds.length === 1) {
          templatesPromises.push(ApiService.program.get(terminal.templateIds[0], true));
        }
      });

      return $q.all(templatesPromises).then(function (response) {
        response.forEach(function (template) {
          ctrl.templatesData[template.data.payload.id] = template.data.payload.name;
        });
      });
    },

    processTerminals: function (terminals) {
      return terminals.map(function (terminal) {
        let templatesMap = 'All';

        if (terminal.templateIds) {
          if (terminal.templateIds.length === 1) {
            templatesMap = ctrl.templatesData[terminal.templateIds[0]];
          } else if (terminal.templateIds.length > 1) {
            templatesMap = terminal.templateIds.length + ' events';
          }
        }

        return Object.assign(terminal, {
          templatesMap: templatesMap,
        });
      });
    },

    success: {
      init: function (response) {},
      getTerminals: function (response) {
        const terminals = response.data.payload;

        ctrl.pullTemplatesData(terminals.list).then(function () {
          ctrl.model = ctrl.processTerminals(terminals.list);

          //this will reset selectedRows stack
          ctrl.selectedRows = [];
          ctrl.isLoaded = true;
          ctrl.gridDefinition.isLoaded = true;

          //next tick
          $timeout(function () {
            ctrl.search();
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: ctrl.gridDefinition.options.gridName,
              datasetLength: ctrl.filtered.length,
              totalItems: terminals.pagination.count,
            });
          }, 0);
        });
      },
      create: function (response) {
        ctrl.model.push(response.data.payload);
        $timeout(function () {
          ctrl.search();
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.filtered.length,
            totalItems: ctrl.gridDefinition.options.totalItems + 1,
          });
        }, 0);
      },
      update: function (response) {},
      remove: function (response) {
        //next tick
        $timeout(function () {
          ctrl.search();
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: ctrl.gridDefinition.options.gridName,
            datasetLength: ctrl.filtered.length,
            totalItems: ctrl.gridDefinition.options.totalItems - 1,
          });
        }, 0);
      },
    },

    error: {
      init: function (response) {},
      getTerminals: function (response) {
        ctrl.isLoaded = true;
      },
      create: function (response) {},
      update: function (response) {},
      remove: function (response) {},
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      ctrl.gridState.updateGridState(newPage, pageSize);
      if (sortField) {
        ctrl.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        ctrl.gridState.updateGridState(null, null, null, sortDirection);
      }
      ctrl.getTerminals();
    },

    onDataGridSortChange: function (grid, columns, page) {
      const data = columns[0];
      ctrl.gridState.updateGridState(page || null, null, data.field, data.sort.direction);
      ctrl.getTerminals();
    },
  };

  $scope.settingsTerminals = ctrl;
  ctrl.init();
}

export const SettingsTerminalControllerModule = angular
  .module('acme.view.application.settings.terminals.controllers', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.permissions',
    'acme.common.service.terminals',
    'acme.common.factory.notice',
    'acme.view.application.settings.terminals.createModal.controllers',
    'acme.view.application.settings.terminals.removeModal.controllers',
    'acme.view.application.settings.terminals.configurationModal.controllers',
    'acme.view.application.settings.terminals.posCloudConfigurationModal.controllers',
    OrdersModalsRequestControllerModule,
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
  ])
  .controller('SettingsTerminalsController', SettingsTerminalsController).name;
